

  import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
  import eventTrackingFiveStarFnMixins from '~/mixins/eventTrackingFiveStarFnMixins.js';
  import pageMeta from '~/mixins/pageMeta.js';


  export default {
    mixins: [pageMeta, eventTrackingMixins, eventTrackingFiveStarFnMixins],

    data() {
      return {
        pages: {
          type: Object,
          default: () => {},
        },
        loading: 0,
        dataReady: false,
      };
    },

    props: {
      productCat: {
        type: Array,
        default: () => [],
      },
      productCats: {
        type: Array,
        default: () => [],
      },
      dataLoading: {
        type: Boolean,
        default: true,
      }
    },

    // head() {
    //   return {
    //   title: this.firstSubcatObj?.PageMeta?.Title,
    //   meta: [
    //     {
    //       hid: 'og:title', name: 'og:title', property: 'og:title',
    //       content: this.firstSubcatObj?.PageMeta?.Title,
    //     },
    //     {
    //       hid: 'og:description', name: 'og:description', property: 'og:description',
    //       content: this.firstSubcatObj?.PageMeta?.Description,
    //     },
    //     {
    //       hid: 'description', name: 'description',
    //       content: this.firstSubcatObj?.PageMeta?.Description,
    //     },
    //     {
    //       hid: 'og:image', name: 'og:image', property: 'og:image',
    //       content: this.firstSubcatObj?.PageMeta?.Image?.url,
    //     },
    //   ]
    //   }
    // },

    computed: {
      currentCategory() {
        if (this.productCats[0]) {
          return this.productCats[0].five_star_categories.find((item) => item.slug === this.$route.params.any)
        }
        return {}
      },
      productCategories() {
        if (!this.productCats[0])
          return null
        else
          return this.productCats[0]?.five_star_categories
      },
      productSubcategories() {
        if (!this.productCat[0]?.SubCategory)
          return null
        else
          return this.productCat[0]?.SubCategory
      },
      firstSubcatObj() {
        return this.productCat[0]?.SubCategory[0]
      },
      pageData() {
        return this.productCat[0];
      },
      isReady() {
        return this.isEventTrackingReady;
      }
    },
    watch: {
      productSubcategories(newValue, oldValue) {
        if (newValue !== oldValue) {
              console.debug('subcategories changed...')
              this.dataReady = true
            }
      },
      "$route.params.productCat"(newValue, oldValue) {
        console.debug("$route.params.productCat changed: ", newValue, oldValue)
      }
    },

    methods: {
      getFirstSubCategory(){
        console.debug('this.productCat[0].....')
        console.debug(this.productCat[0])
        // return this.productCat[0].SubCategory.find((item) => item.Slug )
      },
    },
  }
